import { LanguageType } from "./types/data";

export const formatCurrency = (val: number, lang : LanguageType): string => {
    return new Intl.NumberFormat(`${lang}-CA`, { style: 'currency', currency: 'CAD', minimumFractionDigits: 0 }).format(val);
};